module.exports = __webpack_public_path__ + "img/darren.2b7bd8f6.png";